import { render, staticRenderFns } from "./WidgetWTsStillToShip.vue?vue&type=template&id=6b13a88f"
import script from "./WidgetWTsStillToShip.vue?vue&type=script&lang=js"
export * from "./WidgetWTsStillToShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports